const LOCK_CLASS = 'mp-dashboard-modal-scroll-lock'
const STYLE_KEYS = ['overflow', 'overflowY', 'pointerEvents', 'touchAction', 'overscrollBehavior']

let snapshot = null
const owners = new Map()

const diagnostic = (event, detail = {}) => console.info('[member-modal]', { event, ...detail })
const captureStyles = element => Object.fromEntries(STYLE_KEYS.map(key => [key, element.style[key]]))
const restoreStyles = (element, styles) => STYLE_KEYS.forEach(key => { element.style[key] = styles[key] })

/** Shared, counter-based scroll lock. Each returned release function is idempotent. */
export function acquireModalScrollLock(owner = 'member-dashboard-modal') {
  const token = Symbol(owner)
  if (owners.size === 0) {
    if (document.body.classList.contains(LOCK_CLASS) || document.documentElement.classList.contains(LOCK_CLASS)) {
      document.body.classList.remove(LOCK_CLASS)
      document.documentElement.classList.remove(LOCK_CLASS)
      diagnostic('stale_lock_cleanup_performed', { remainingLockCount: 0 })
    }
    snapshot = {
      body: captureStyles(document.body),
      documentElement: captureStyles(document.documentElement),
      main: [...document.querySelectorAll('.mp-main, .mp-membership')].map(element => ({ element, styles: captureStyles(element), scrollTop: element.scrollTop, scrollLeft: element.scrollLeft })),
    }
    diagnostic('prior_styles_captured', { owner, bodyCaptured: true, documentElementCaptured: true })
  }
  owners.set(token, owner)
  document.body.classList.add(LOCK_CLASS)
  document.documentElement.classList.add(LOCK_CLASS)
  document.body.style.overflow = 'hidden'
  document.documentElement.style.overflow = 'hidden'
  snapshot?.main?.forEach(({ element }) => {
    element.style.overflowY = 'hidden'
    element.style.touchAction = 'none'
    element.style.overscrollBehavior = 'none'
  })
  diagnostic('scroll_lock_acquired', { owner, remainingLockCount: owners.size })

  let released = false
  return () => {
    if (released) return
    released = true
    owners.delete(token)
    if (owners.size === 0 && snapshot) {
      restoreStyles(document.body, snapshot.body)
      restoreStyles(document.documentElement, snapshot.documentElement)
      snapshot.main.forEach(({ element, styles, scrollTop, scrollLeft }) => {
        restoreStyles(element, styles)
        // Flush the restored scrollbar geometry before restoring the saved offset.
        // Otherwise scroll anchoring can shift it after the lock is released.
        element.getBoundingClientRect()
        element.scrollTop = scrollTop
        element.scrollLeft = scrollLeft
      })
      document.body.classList.remove(LOCK_CLASS)
      document.documentElement.classList.remove(LOCK_CLASS)
      snapshot = null
    }
    diagnostic('scroll_lock_released', { owner, remainingLockCount: owners.size })
  }
}

export function modalScrollLockCount() { return owners.size }
